import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyService {
  loyaltyPoints: any = { }
  loyaltySubject = new Subject<any>();

  constructor(private http: HttpClient) {
    this.loyaltySubject.subscribe(x => this.loyaltyPoints = x);
    this.getLoyaltyPoints()
  }

  getLoyaltyPoints() {
    this.http.get<{ total: number, remaining: number, level: number, rewards: any[] }>(`/api/loyalty`)
    .subscribe(x => this.loyaltySubject.next(x))
  }

  getRewards() {
    return this.http.get<{ rewards: { id: number, price: number, src: string, name: string, level: number }[], level?: number, startPoints: number, total?: number, nextLevel?: number }>(`/api/loyalty/rewards`)
  }

  redeem(reward) {
    return this.http.post<{ success: boolean }>(`/api/loyalty/redeem`, { rewardId: reward.id })
  }

  refund(rewardId) {
    return this.http.post<{ success: boolean }>(`/api/loyalty/refund`, { rewardId })
  }
}
